import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from "react-loadable";
import MenuComp from "../layout/Menu";
import { Spin } from 'antd';
import './index.less';

const Loading = (loader: any) => {
  return Loadable({
    loader,
    loading: () => {
      return <Spin tip="Loading..." />;
    }
  });
};

const Main = Loading(() => import("./Main"));
const CourseCenter = Loading(() => import("./Main/course"));
const TextCenter = Loading(() => import("./Main/exam"));
const TextDetail = Loading(() => import("./Main/exam/detail"));
const ActivityDetail = Loading(() => import("./Main/activity/detail"));
const Knowledge = Loading(() => import("./Main/knowledge"));
// const ProjectCenter = Loading(() => import("./Main/project"));
// const TopicCenter = Loading(() => import("./Main/topic"));
const CourseDetail = Loading(() => import("./Main/course/Detail"));
const UserComponent = Loading(() => import("./User/index"));
const ErrorComp = Loading(() => import("../../components/Empty"));

interface IProps {
  userinfo: any;
};
export default class Index extends Component<IProps> {

  render() {
    const userinfo = JSON.parse(localStorage.getItem('userinfo') || JSON.stringify(null)) || {};
    return (
      <div className='total_page'>
        <div className="nav_top" style={{ background: '#000' }}>
          <MenuComp userinfo={userinfo} />
        </div>
        <div className='total_bot'>
          <Switch>
            <Route path="/college/menu/main/activity/:id" component={ActivityDetail} />
            <Route path="/college/menu/user" component={UserComponent} />
            <Route path="/college/menu/main/course/detail/:id" component={CourseDetail} />
            <Route path="/college/menu/main/course" component={CourseCenter} />
            <Route path="/college/menu/main/exam/:id/:attribute" component={TextDetail} />
            <Route path="/college/menu/main/knowledge" component={Knowledge} />
            {/* <Route path="/college/menu/main/exam" component={TextCenter} /> */}
            {/* <Route path="/college/menu/main/activity" component={ActivityCenter} /> */}
            {/* <Route path="/college/menu/main/project" component={ProjectCenter} />
            <Route path="/college/menu/main/topic" component={TopicCenter} /> */}
            <Route path="/college/menu/main" component={Main} />
            <Route component={ErrorComp} />
          </Switch>
        </div>
      </div>
    )
  }
}
